import CheckedIcon from './CheckedIcon';
import UncheckedIcon from './UncheckedIcon';

const CustomCheckbox = ({ checked }: { checked: boolean }) => {
	return checked ? <CheckedIcon /> : <UncheckedIcon />;
};
export default CustomCheckbox;
